{
  "title": "House of Cards (UA)",
  "source": "Unearthed Arcana 85 - Wonders of the Multiverse",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S, M (a deck of cards)",
  "duration": "24 hours",
  "description": [
    "You touch the ground and conjure forth a defensive structure made of enormous playing cards. The structure rises with you at its center, harmlessly lifting you and any creatures in the area. The house of cards has a square base that is 30 feet on each side, and it has three floors with 10-foot-high ceilings. The second floor is 20 feet on each side, and the top floor is 10 feet on each side—both centered above the bottom floor. Ramps connect the interior of each floor, and empty doorframes connect the interior and exterior of each level. Creatures inside or on top of the structure have half cover.",
    "Each card that comprises the house is 5 feet wide and 10 feet tall and is very fragile. A card has AC 10 and 1 hit point. The cards are immune to poison and psychic damage. Reducing a card to 0 hit points destroys it. Every time a card is destroyed, roll 1d6. If you roll a 5 or a 6, the house collapses, ending the spell.",
    "The house and all its cards vanish when the spell ends."
  ],
  "spellLists": ["artificer", "bard", "sorcerer", "wizard"]
}
